import config, { BuildType, BuildTypeFor } from '@/config';

export default (): boolean => {
  return config.buildType === BuildType.CAPACITOR && config.buildTypeFor === BuildTypeFor.android;
};
